import api from "../api/api";
import { ResetPasswordInterface } from "../interfaces";

class AuthService {
  async login(username: string, password: string) {
    try {
      const response = await api.post("token/", {
        username: username,
        password: password,
        });
        localStorage.setItem("token", JSON.stringify(response.data));
        return response.data;
    } catch (error) {
        return error;
        }
    }

    async logout() {
      await api.post("logout/", {}).then(() => {});
    }

    getCurrentUser() {
      return JSON.parse(localStorage.getItem("token") || "{}");
    }

    async forgotPassword (email: string) {
      return await api.post('forgot-password', {email: email}).then(res => res);
    }

    async resetPassword (token: string, email: string, data: ResetPasswordInterface) {
      return await api.post(`reset-password?token=${token}&email=${email}`, data).then(res => res);
    }
}

export const authService = new AuthService();
